import React, { Component } from 'react';
import { Button, Modal } from 'antd';
import store from '@/store'
import OpenFile from 'Components/GetStartGuid/OpenFile/OpenFile';
import './index.scss'
import { DRAG_FILE_TO_OPEN } from 'Components/viewer/ui/constants/other.constants';

function useIdleCallback(fn){
    let handle = ((window.requestIdleCallback||setTimeout)(()=>{
        fn()
        if(window.requestIdleCallback)
            cancelIdleCallback(handle);
    }))
}

class ESignCNDialog extends Component {
    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.goEsignFromEsignTable = this.goEsignFromEsignTable.bind(this);
    }

    componentDidMount() {
        console.log('props', this.props);
    }

    componentWillUnmount() {
    }

    onDropFileOnViewer = (acceptedFiles) => {
        let file = acceptedFiles[0];
        if (!file) {
            return
        }
        const mimeType = file.type
        store.docStore.setDocDriveName("")
        const isPossiblePDF = (mimeType == 'application/pdf') || (mimeType == '')

        const fn = () => {
            if (isPossiblePDF) {
                store.viewer.doOpenFile(file, (isLoading)=>{
                    isLoading && this.doShowEditorLoading();
                })
            }

            useIdleCallback(()=>{
                store.appStore.showLoadingWithMsg({show:true,msg:"Loading.file"})
                store.appStore.setCommonMode(
                    () => {
                        store.appStore.showLoading(false);
                    })
                store.userStore.doSendGAEvent({ eventKey: DRAG_FILE_TO_OPEN, label: 'getting_started' });
            })
        };

        if(!store.viewer.hasOpenFile || !store.appStore.docModified){
            fn();
            return;
        }

        if (store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage) {
            return store.appStore.onShowToSaveBeforeOpen(isToSave => {
                !isToSave && store.appStore.doUpdateDocModified(false);
                !isToSave && fn();
            })
        }
        this.onShowToSaveBeforeOpen((isToSave)=>{
            !isToSave && store.appStore.doUpdateDocModified(false);
            !isToSave && fn();
        })
    }

    onCancel() {
        this.props.closeDialog()
    }
    goEsignFromEsignTable(files) {
        this.props.closeDialog();
        this.onDropFileOnViewer(files);
        store.viewer.setEditorTabName('esignCN-tab');
    }

    render() {
        const { opts: { id, title, msg }, visible } = this.props;
        let footer;
        console.log('id', id);
        if (id === 'SIGN_RECORD_OPEN_FILE_CONFIRM') {
            footer = [
                <div key="submit" className='openFileContainer'><OpenFile onlyButton={true} supportDocumentSuffixs={`.pdf,PDF`}  onDrop={this.goEsignFromEsignTable}  openFile={this.goEsignFromEsignTable} className='open-file-container'/></div>,
                <Button key="back" onClick={this.onCancel}>取消</Button>
            ]
        } else {
            footer = [
                <Button key="submit" onClick={this.onCancel}>确认</Button>,
                <Button key="back" onClick={this.onCancel}>取消</Button>
            ]
        }
        return (
            <Modal
                title={title}
                visible={visible}
                onCancel={this.onCancel}
                okText="确认"
                cancelText="取消"
                footer={footer}
            >
                <p>{msg}</p>

            </Modal>
        );
    }
}

export default ESignCNDialog;